import { useState } from "react";
import { X } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "plan_review_pilot_banner_dismissed";

export function PlanReviewPilotBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  return (
    <Alert className="relative border-border bg-muted/40 pr-10">
      <AlertDescription className="text-sm text-foreground">
        Plan Review helps speed up your review. Results are AI-assisted; your team makes the final call.
        We&apos;re improving this with your feedback.
      </AlertDescription>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute right-1 top-1 h-7 w-7"
        aria-label="Dismiss"
        onClick={() => {
          setDismissed(true);
          try {
            sessionStorage.setItem(STORAGE_KEY, "1");
          } catch {
            /* ignore */
          }
        }}
      >
        <X className="h-4 w-4" />
      </Button>
    </Alert>
  );

}
